// Project Imports
import getFormattedDateByFrequency from 'core/utils/getFormattedDateByFrequency';

export default function getTimeLineDropdownList(
  timelineResponse,
  frequencyType
) {
  if (timelineResponse && frequencyType) {
    const timeLineDropdownList = timelineResponse?.map((item) =>
      getFormattedDateByFrequency(frequencyType, item?.frequency_value)
    );
    return timeLineDropdownList;
  }
  return [];
}
